import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Tree } from 'primereact/tree';
import { InputText } from 'primereact/components/inputtext/InputText';

const DialogType = Object.freeze({
  none: 0,
  delete: 1,
  rename: 2,
  newFolder: 3,
  switchLoc: 4,
});

export default class StandardFoldersEditDialog extends React.Component {
  constructor(props) {
    super(props);
  }

  makeTextInput() {
    const { newNodeDataName, setNewNodeDataName } = this.props;
    return (
      <span className="p-float-label" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
        <InputText
          autoFocus
          style={{ width: '20rem' }}
          id="dialogInpText"
          value={newNodeDataName || ''}
          onChange={(e) => setNewNodeDataName(e.target.value)}
        />
        <label htmlFor="dialogInpText">Objektname</label>
      </span>
    );
  }

  getDialogText() { // Folder only
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        // return currentNode.selectable
        //  ? `Möchten Sie die Standardtabelle '${currentNode.data.name}' wirklich löschen?`
        //  : (
        return (
          <div>
            <p><h3>{`Möchten Sie den Ordner '${currentNode.data.name}' wirklich löschen?`}</h3></p>
          </div>
        );
      case DialogType.rename:
        return <h3>{`Bitte geben Sie einen neuen Namen für den Ordner '${currentNode.data.name}' ein.`}</h3>;
      case DialogType.newFolder:
        return <h3>Bitte geben Sie einen Namen für den zu erstellenden Ordner ein.</h3>;
      case DialogType.switchLoc:
        return <h3>{`Bitte wählen Sie aus, wohin Sie '${currentNode.data.name}' verschieben wollen:`}</h3>;
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogHeader() {
    const { currentDialogType, currentNode } = this.props;

    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.newFolder:
        return 'Unterordner erstellen';
      case DialogType.switchLoc:
        return currentNode.selectable ? 'Ordner verschieben' : 'Ordner verschieben';
      default:
        return 'Ungültiger Typ';
    }
  }

  getDialogConfirmButtonText() {
    const { currentDialogType, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return 'Löschen';
      case DialogType.rename:
        return 'Umbenennen';
      case DialogType.newFolder:
        return 'Erstellen';
      case DialogType.switchLoc:
        return currentNode.selectable ? 'Ordner verschieben' : 'Ordner verschieben';
      default:
        return 'Ungültiger Typ';
    }
  }

  isButtonEnabled() {
    const { currentDialogType, newNodeDataName, selectedTreeNodeKey, currentNode } = this.props;
    switch (currentDialogType) {
      case DialogType.delete:
        return true;
      case DialogType.rename:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.newFolder:
        if (newNodeDataName && newNodeDataName.trim().length > 0) {
          return true;
        }
        return false;
      case DialogType.switchLoc:
        let compareKey = '';
        if (currentNode.key) {
          compareKey = currentNode.key.substring(0, 3);;
        }
        if (selectedTreeNodeKey && selectedTreeNodeKey.length === 3 && selectedTreeNodeKey !== compareKey) return true;
        return false;
      default:
        return 'Ungültiger Typ';
    }
  }

  renderFooter() {
    const { onHide, confirmDialog } = this.props;

    return (
      <div>
        <Button
          id="continue"
          disabled={!this.isButtonEnabled()}
          label={this.getDialogConfirmButtonText()}
          icon="pi pi-check"
          onClick={() => confirmDialog()}
        />
        <Button
          id="cancel"
          label="Abbrechen"
          className="p-button-danger"
          icon="pi pi-times"
          onClick={() => onHide()}
        />
      </div>
    );
  }

  makeFileSelectionTree() {
    const { allNodes, selectedTreeNodeKey, currentNode } = this.props;
    const nodes = this.convertNodesForTree(JSON.parse(JSON.stringify(allNodes)), currentNode);
    return (
      <div>
        <div className="card">
          <Tree
            style={{ width: '35rem' }}
            value={nodes}
            selectionMode="single"
            selectionKeys={selectedTreeNodeKey}
            onSelectionChange={(e) => this.onTreeNodeSelectionChange(e.value)}
          />
        </div>
      </div>
    );
  }

  onTreeNodeSelectionChange(newFatherNodeKey) {
    const { setSelectedTreeNodeKey } = this.props;
    setSelectedTreeNodeKey(newFatherNodeKey);
  }

  convertNodesForTree(nodes) {
    const { currentNode } = this.props;
    nodes.forEach((node) => {
      node.label = node.data.name;
      node.selectable = !node.selectable;
      if (node.key.startsWith(currentNode.key)) {
        node.selectable = false;
      }

      delete node.data;
      if (node.children) {
        this.convertNodesForTree(node.children);
      }
    });
    return nodes;
  }

  render() {
    const { onHide, currentDialogType } = this.props;
    console.log('RENDER#44', currentDialogType);
    let style;
    if (currentDialogType === 4) {
      style = {
        overflowY: 'scroll',
        width: '42rem',
        top: '10px',
        transform: 'unset',
        left: '400px',
        height: '620px',
      };
    } else {
      style = {
        width: '42rem',
        top: '10px',
        transform: 'unset',
        left: '400px',
      };
    };
    return (
      <Dialog
        header={this.getDialogHeader(currentDialogType)}
        visible={!!currentDialogType}
        style={style}
        footer={this.renderFooter()}
        onHide={() => onHide()}
        modal
      >
        <div>{this.getDialogText(currentDialogType)}</div>
        {currentDialogType === DialogType.switchLoc ? this.makeFileSelectionTree() : undefined}
        {(currentDialogType === DialogType.newFolder || currentDialogType === DialogType.rename)
          ? this.makeTextInput() : undefined}
      </Dialog>
    );
  }
}
